import { getUrlVars } from "../modules/query-string";
import "../lib/jquery.megamenu";
import "../lib/jquery.menu-aim";

function getCurrentlySelectedCategory(): string {
  let catid = "40";
  const page = document.location.pathname.toLowerCase();
  if (
    page.indexOf("/default.aspx") >= 0 ||
    page.charAt(page.length - 1) == "/"
  ) {
    catid = "65";
  } else {
    const urlParams = getUrlVars();
    if (urlParams["categoryid"] !== undefined) {
      catid = urlParams["categoryid"];
    }
  }
  return catid;
}

export function setupNavigation($: JQueryStatic) {
  const $hgsNav = $("#hgsnav");
  try {
    if ($hgsNav.hasClass("legacy")) {
      $hgsNav.hgsmegamenu({
        anchorSizeSelector: "a",
      });
      $(".megamenu").addClass("legacy");
    } else {
      $hgsNav.hgsmegamenu({
        anchorSizeSelector: "span",
      });
    }
  } catch (e) {
    // fail silently
    console.log('error during building of megamenu: ' + e);
  }

  // set current category to active in navigation
  const catid = getCurrentlySelectedCategory();
  const search = `a[href$="=${catid}"]`;
  $hgsNav.find(search).parent().addClass("active");

  setupSubMenus($);
}

function setupSubMenus($: JQueryStatic) {
  $("ul.level-1 li:has(div.sub-categories) > span").addClass("has-panel");

  function activateSubmenu(row) {
    const $row = $(row),
      $currentmenu = $row.parents(".megamenu").first(),
      $currentlist = $row.parents("ul.level-1").first(),
      width = $currentlist.outerWidth(true),
      $navtext = $row.children("span.nav-text").first(),
      $submenu = $row.children(".sub-categories");

    $currentlist.find(".sub-categories").css("display", "none");

    $navtext.addClass("active");

    if ($submenu.length > 0) {
      const height = $currentmenu.outerHeight();

      $submenu.css({
        display: "block",
        top: 0,
        left: width - 3, // main should overlay submenu
        height: height, // padding for main dropdown's arrow
        position: "absolute",
      });

      $row
        .parents(".megamenu")
        .stop()
        .animate({ width: 650 }, { queue: false });
    }
  }

  function deactivateSubmenu(row) {
    const $row = $(row),
      $currentlist = $row.parents("ul.level-1").first(),
      $submenu = $row.children(".sub-categories"),
      $navtext = $row.children("span.nav-text").first(),
      width = $currentlist.outerWidth(true);

    $navtext.removeClass("active");

    if ($submenu.length > 0) {
      $row
        .parents(".megamenu")
        .stop()
        .animate(
          { width: width },
          {
            queue: false,
            complete: function () {
              $submenu.css("display", "none");
            },
          }
        );
    }
  }

  try {
    // jQuery-menu-aim: <meaningful part of the example>
    // Hook up events to be fired on menu row activation.
    $("ul.level-1").menuAim({
      activate: activateSubmenu,
      deactivate: deactivateSubmenu,
    });
  } catch (ex) {
    // fail silently
    console.log('unable to menu aim: ' + ex)
  }

  $(".level-2 li").has(".submenuimage").css("position", "static");
}
